import { BaseFadeTransition } from './BaseFadeTransition';

export class DipToBlackFadeTransition extends BaseFadeTransition {

    getDisplayName() {
        return 'Vervagen naar zwart';
    }

    shouldWaitForTransitionEnd() {
        return true;
    }
}
